// extracted by mini-css-extract-plugin
export default {"container":"TimeClock_container__zFdM6"};